import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Hero from '../../components/Hero/Hero';
import gallery from '../../data/gallery';
import heroBg from '../../assets/images/gallery/office/all-staff-faces.png';
import './Gallery.css';

const allCategories = ['All', ...gallery.map((g) => g.category)];

const Gallery = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const filteredImages =
    activeCategory === 'All'
      ? gallery.flatMap((g) => g.images)
      : gallery.find((g) => g.category === activeCategory)?.images || [];

  const openLightbox = (index) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  return (
    <div className="gallery-page">
      <Hero
        title={<>Our <span className="highlight">Gallery</span></>}
        subtitle="A glimpse into our facilities, team, and company activities."
        backgroundImage={heroBg}
      />

      <section className="gallery section">
        <div className="container">
          <div className="gallery__filters">
            {allCategories.map((cat) => (
              <button
                key={cat}
                className={`gallery__filter ${activeCategory === cat ? 'gallery__filter--active' : ''}`}
                onClick={() => setActiveCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>

          <div className="gallery__grid">
            {filteredImages.map((image, idx) => (
              <div
                className="gallery__item"
                key={idx}
                onClick={() => openLightbox(idx)}
              >
                <img src={image.src} alt={image.title} loading="lazy" />
                <div className="gallery__item-overlay">
                  <span className="gallery__item-title">{image.title}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        index={lightboxIndex}
        slides={filteredImages.map((img) => ({ src: img.src, alt: img.title }))}
      />
    </div>
  );
};

export default Gallery;
